import EditionPage from './EditionPage';

const FTM_2019 = {
  eyebrow: 'Long-loved edition',
  crumb: 'Family Tree Maker 2019',
  title: 'Family Tree Maker 2019 Support',
  lead: 'Keep FTM 2019 running smoothly — or upgrade safely when you are ready. We help with sync, media, color coding, and more.',
  overviewTitle: 'Still going strong years later',
  overview: [
    'Family Tree Maker 2019 introduced a more reliable FamilySync, color coding for family lines, built-in photo repair, and TreeVault cloud storage. It is still installed on a huge number of computers.',
    'If it does everything you need, there is no pressure to upgrade. We are happy to keep it running for you — and when you do decide to move to 2024, we will make sure every person, photo, and sync link comes with you.',
  ],
  image: '/images/feature-charts.webp',
  imageAlt: 'A family tree chart created in Family Tree Maker 2019',
  featuresTitle: 'Tools FTM 2019 users love',
  features: [
    { icon: 'sync', title: 'Steadier FamilySync', text: 'Two-way syncing with Ancestry that is far more reliable than earlier TreeSync.' },
    { icon: 'leaf', title: 'Color coding', text: 'Give each branch its own color so you can see who belongs where at a glance.' },
    { icon: 'photo', title: 'Photo repair', text: 'Lighten, sharpen, and fix scratched old photos without a separate editor.' },
    { icon: 'cloud', title: 'TreeVault', text: 'Store copies of your trees online for safekeeping and easy restores.' },
    { icon: 'shield', title: 'FamilySearch link', text: 'Compare people with the FamilySearch Family Tree and bring back missing facts.' },
    { icon: 'book', title: 'Books & charts', text: 'Detailed reports and family history books through the Family Book Creator plugin.' },
  ],
  specs: [
    ['Operating system', 'Windows 10 or 11', 'macOS 10.12 or later'],
    ['Processor', '1 GHz or faster', 'Intel; Apple silicon via Rosetta'],
    ['Memory', '2 GB RAM (4 GB recommended)', '2 GB RAM (4 GB recommended)'],
    ['Disk space', '500 MB plus trees & media', '500 MB plus trees & media'],
    ['Internet', 'Needed for activation, updates & sync', 'Needed for activation, updates & sync'],
  ],
  issuesTitle: 'FTM 2019 problems we solve',
  issues: [
    ['FamilySync errors or endless syncing', 'fix-familysync-errors'],
    ['Broken photo links after moving files', 'relink-missing-media'],
    ['Slow tree or file corruption warnings', 'keep-your-tree-file-healthy'],
    ['Transferring 2019 to a new computer', 'move-family-tree-maker-to-new-computer'],
    ['Ancestry login keeps failing', 'ancestry-sign-in-problems'],
  ],
  faqs: [
    {
      q: 'Is Family Tree Maker 2019 still supported?',
      a: 'The publisher focuses updates on the current edition, but FTM 2019 still runs well on many computers. We continue to help FTM 2019 users with every common problem.',
    },
    {
      q: 'Should I upgrade to 2024?',
      a: 'If you are buying a new computer, moving to a new operating system, or seeing compatibility problems, upgrading is usually the simplest fix. Otherwise, there is no rush.',
    },
    {
      q: 'How do I keep my FTM 2019 tree from getting damaged?',
      a: 'Exit the program normally, let syncs finish, keep the tree on your internal drive, compact the file occasionally, and back up after every session.',
    },
  ],
  ctaTitle: 'Need help with Family Tree Maker 2019?',
};

export default function Ftm2019Page() {
  return <EditionPage edition={FTM_2019} />;
}
